module.exports = __webpack_public_path__ + "static/media/social.f9be4488.svg";